module.exports = __webpack_public_path__ + "img/slider.15306bfb.svg";